import PhotoListEmpty from "./PhotoListEmpty";

export default PhotoListEmpty;
